import { render, staticRenderFns } from "./EditReportCustom.vue?vue&type=template&id=61b77082"
import script from "./EditReportCustom.vue?vue&type=script&lang=js"
export * from "./EditReportCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports